import { Layout, Row } from 'antd';
import React from 'react';
import { ThemeProvider } from 'react-jss';
import { Route } from 'react-router-dom';
import Footer from './containers/Footer';
import Header from './containers/header';
import { competences } from './data';
import Competence from './pages/competence';
import Contact from './pages/contact';
import Home from './pages/home';
import Honoraires from './pages/honoraires';

const { Content } = Layout;

const theme = {};

const App = () => (
  <ThemeProvider theme={theme}>
    <Layout style={{ height: '100%' }}>
      <Header />
      <Content style={{ backgroundColor: '#EEEEEE', paddingTop: '4em' }}>
        <main>
          <Row justify="center" type="flex">
            <Route exact path="/" component={Home} />
            <Route exact path="/honoraires" component={Honoraires} />
            <Route exact path="/contact" component={Contact} />

            {competences.map((competence) => (
              <Route
                exact
                path={`/competences/${competence.name}`}
                render={() => <Competence {...competence} />}
              />
            ))}
          </Row>
        </main>
      </Content>
      <Footer />
    </Layout>
  </ThemeProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js